import React from "react";
import styles from "./PrivacyPage.module.css";

export default function PrivacyPage() {
  return (
    <div className={styles.container}>
      <h1 className="amsterdam">Terms of Services</h1>
      <p className="moderustic">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium
        animi dignissimos, minus cupiditate voluptate tempora dolor corrupti,
        nisi blanditiis et adipisci eius atque tempore fuga rerum suscipit enim
        hic nostrum?
      </p>
      <p className="moderustic">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique dicta
        modi sed delectus facilis accusamus libero eveniet ullam, quam eaque
        adipisci sit ut optio, officia incidunt cupiditate, qui culpa at! Lorem
        ipsum dolor sit amet consectetur, adipisicing elit. Ipsum minima ut
        voluptatum atque sint. Omnis numquam nisi aut accusamus, cum minus
        possimus voluptas repellat beatae unde. Voluptate odit eligendi tempore.
      </p>
      <p className="moderustic">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quam, repellat
        placeat inventore excepturi adipisci distinctio numquam. Autem rerum, in
        nam vero voluptatum quas possimus quam, neque laboriosam sint laudantium
        impedit!
      </p>
    </div>
  );
}
